import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { GuardResult, MaybeAsync } from '@angular/router/router_module.d-BivBj8FC';


export const notAuthenticatedGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {

  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  const isAnonymous = !authenticationService.isUserConnected();

  if (!isAnonymous) {
    return router.navigate(['private']);
  }

  return isAnonymous;
};


